import React from "react";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {CInputGroup, CLabel, CSwitch} from "@coreui/react";
import "./RuleSwitcher.scss";

const RuleSwitcher = (props) => {
  const {switcherHandler, className, checked, disabled} = props;
  const {t} = useTranslation();

  return (
    <CInputGroup className={classNames("RuleSwitcher", className)}>
      <CLabel htmlFor="ruleSwitcher" className="RuleSwitcher__label">
        {
          checked ?
            t("rule.switcher.on", "The rule is On") :
            t("rule.switcher.off", "The rule is Off")
        }
      </CLabel>
      <CSwitch
        size="sm"
        color="info"
        id="ruleSwitcher"
        checked={checked}
        disabled={disabled}
        onChange={switcherHandler}
        className="RuleSwitcher__switch"
      />
    </CInputGroup>
  );
};

export default RuleSwitcher;